/**
 * Создает функцию getCurrentState для получения текущего состояния из setState функции, используемой в React.
 *
 * @param {function} setState Функция setState из хука useState в React.
 * @returns {function(): Promise<*>} Функция getCurrentState, которая возвращает Promise с текущим состоянием.
 */

export const createGetterFromSetState = (setState) => {
    const getCurrentState = () => {
        return new Promise((resolve) => {
            setState((state) => {
                resolve(state);
                return state;
            });
        });
    };

    return getCurrentState;
};
